import { Accordion } from './accordion';
import { Avatar } from './avatar';
import { Button } from './button';
import { Card } from './card';
import { Checkbox } from './checkbox';
import { Input } from './input';
import { Link } from './link';
import { Progress } from './progress';
import { Radio } from './radio';
import { Select } from './select';
import { Tabs } from './tabs';
import { Textarea } from './textarea';
import { tagTheme as Tag } from '../../components/tag';
export default {
    Accordion,
    Avatar,
    Button,
    Card,
    Checkbox,
    Input,
    Link,
    Progress,
    Radio,
    Select,
    Tabs,
    Tag,
    Textarea
};

//# sourceMappingURL=index.js.map